import { ActorMovementType } from "./ActorMovementType";
import { Vec2D } from "./Vec2D";

export const activitiesMapped = new Map<string, string>([
  ["None", "/dialog_quiz/dialog_quiz_npc.png"],
  ["NormalTalkingLoop", "/dialog_quiz/dialog_quiz_npc.png"],
  ["Thinking", "/dialog_quiz/dialog_quiz_npc.png"],
]);

export const propsMapped = new Map<string, string>([
  ["None", "/actor_props/none.png"],
  ["CoffeeCup", "/actor_props/coffee_cup.png"],
  ["Clipboard", "/actor_props/clipboard.png"],
]);

export const actorActivities: string[] = [
  "None",
  "NormalTalkingLoop",
  "Thinking",
];

export const actorStates: string[] = ["Normal", "Hyperventilating"];

export const actorProps: string[] = ["None", "CoffeeCup", "Clipboard"];

export const defaultActorStateAnimationStateName = "";
export const defaultActorStateAnimationLayer = 0;

export interface ActorStateAnimation {
  id: string;
  stateName: string;
  layer: number;
}

export const defaultActorStateAnimation: ActorStateAnimation = {
  id: "",
  stateName: defaultActorStateAnimationStateName,
  layer: defaultActorStateAnimationLayer,
};

// stores the state of an actor in between takes
export interface ActorState {
  id: string;
  actorId: string;
  positionId: string;
  direction?: Vec2D;
  movement: ActorMovementType;
  lookat: string;
  outfit: string;
  state: string;
  activity: string;
  prop: string;
  resetCharacterParts: boolean;
  animation: ActorStateAnimation;
}

type NormalizableActorState = Omit<
  ActorState,
  "animation" | "resetCharacterParts"
> &
  Partial<Pick<ActorState, "animation" | "resetCharacterParts">>;

export function normalizeActorState(
  actorState: ActorState | NormalizableActorState
): ActorState {
  return {
    ...actorState,
    resetCharacterParts: actorState.resetCharacterParts ?? false,
    animation: actorState.animation ?? defaultActorStateAnimation,
  };
}
